<template>
    <div class="login-page">
        <div class="login-card">
            <h1>Вход</h1>
            <p class="login-subtitle">Авторизуйтесь для доступа к приложению.</p>

            <form @submit.prevent="submit">
                <label class="field">
                    <span>Логин</span>
                    <input v-model.trim="form.userName" type="text" autocomplete="username" required />
                </label>

                <label class="field">
                    <span>Пароль</span>
                    <input v-model="form.password" type="password" autocomplete="current-password" required />
                </label>

                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

                <button class="submit-button" type="submit" :disabled="isSubmitting">
                    {{ isSubmitting ? 'Вход...' : 'Войти' }}
                </button>
            </form>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { api } from '../api';
import { buildBasicAuthToken, setStoredAuth } from '../auth';

const router = useRouter();
const route = useRoute();

const form = reactive({
    userName: '',
    password: ''
});

const errorMessage = ref('');
const isSubmitting = ref(false);

const submit = async () => {
    errorMessage.value = '';
    isSubmitting.value = true;

    const token = buildBasicAuthToken(form.userName, form.password);

    try {
        await api.post('/auth/login', form, {
            headers: {
                Authorization: `Basic ${token}`
            }
        });

        setStoredAuth(token);
        router.replace(route.query.redirect || '/spare-components');
    } catch (error) {
        errorMessage.value = error?.response?.status === 401
            ? 'Неверный логин или пароль.'
            : 'Не удалось выполнить вход.';
    } finally {
        isSubmitting.value = false;
    }
};
</script>

<style scoped>
.login-page {
    min-height: calc(100vh - 140px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-card {
    width: 100%;
    max-width: 420px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 16px 40px rgba(44, 62, 80, 0.15);
    padding: 2rem;
}

.login-card h1 {
    margin-bottom: 0.5rem;
}

.login-subtitle {
    margin-bottom: 1.5rem;
    color: #5f6c7b;
}

.field {
    display: block;
    margin-bottom: 1rem;
}

.field span {
    display: block;
    margin-bottom: 0.4rem;
    color: #2c3e50;
    font-weight: 600;
}

.field input {
    width: 100%;
    margin-right: 0;
}

.error-message {
    margin-bottom: 1rem;
    color: #c0392b;
}

.submit-button {
    width: 100%;
    background: #3498db;
    color: #ffffff;
}

.submit-button:disabled {
    opacity: 0.7;
    cursor: wait;
}
</style>
